const dev = {
  url: {
    API_URL: "https://staging-api.implanteducationonline.net/",
  },
};

const prod = {
  url: {
    API_URL: "https://staging-api.implanteducationonline.net/",
  },
};
export const config = process.env.NODE_ENV === "production" ? prod : dev;

export const API_STATUS = {
  IDLE: "idle",
  LOADING: "loading",
  SUCCESS: "success",
  ERROR: "error",
};

export const AUTH_KEY = "auth";
export const ROLE = "role";

export const COPY_RIGHT_TEXT =
  "© 2002-2026 \u00A0 California Implant Institute, Inc.";
export const WEBSITE_NAME = "www.implanteducation.net";
export const TRY_AGAIN = "Try Again";
export const SORT_KEYS = {
  ASC: "ASC",
  DESC: "DESC",
};

export const REC_PER_PAGE = 25;
export const CANCEL_GET_API_CALL = "Cancel get api";
export const SLIDE_BY = 300;
export const Roles = {
  admin: 1,
  dentist: 2,
};

export const ZOOM_CONSTANT = {
  MAX_ZOOM: 3,
  MIN_ZOOM: 1,
  ZOOM_STEP: 0.1,
};

export const DEFAULT_SUBCATEGORY_COLOR = "#818284";
export const DEFAULT_CARD_IMAGE_COLOR = "#818284";
export const FILE_MAX_SIZE = 5000000;
export const VIDEO_MAX_SIZE = 1.7 * 1024 * 1024 * 1024;
export const UPLOAD_LIMITS = {
  logo: 1,
  documents: 10,
  video: 1,
};
export const SUPPORT_EMAIL = "team@implanteducation.net";

export const countries = [
  "Afghanistan",
  "Albania",
  "Algeria",
  "Andorra",
  "Angola",
  "Antigua and Barbuda",
  "Argentina",
  "Armenia",
  "Australia",
  "Austria",
  "Azerbaijan",
  "The Bahamas",
  "Bahrain",
  "Bangladesh",
  "Barbados",
  "Belarus",
  "Belgium",
  "Belize",
  "Benin",
  "Bhutan",
  "Bolivia",
  "Bosnia and Herzegovina",
  "Botswana",
  "Brazil",
  "Brunei",
  "Bulgaria",
  "Burkina Faso",
  "Burundi",
  "Cambodia",
  "Cameroon",
  "Canada",
  "Cape Verde",
  "Central African Republic",
  "Chad",
  "Chile",
  "China",
  "Colombia",
  "Comoros",
  "Congo, Republic of the",
  "Congo, Democratic Republic of the",
  "Costa Rica",
  "Cote d'Ivoire",
  "Croatia",
  "Cuba",
  "Cyprus",
  "Czech Republic",
  "Denmark",
  "Dominica",
  "Dominican Republic",
  "East Timor",
  "Ecuador",
  "Egypt",
  "El Salvador",
  "Equatorial Guinea",
  "Eritrea",
  "Estonia",
  "Ethiopia",
  "Fiji",
  "Finland",
  "France",
  "Gabon",
  "The Gambia",
  "Georgia",
  "Germany",
  "Ghana",
  "Greece",
  "Grenada",
  "Guatemala",
  "Guinea",
  "Guinea-Bissau",
  "Guyana",
  "Haiti",
  "Honduras",
  "Hungary",
  "Iceland",
  "India",
  "Indonesia",
  "Iran",
  "Iraq",
  "Ireland",
  "Israel",
  "Italy",
  "Jamaica",
  "Japan",
  "Jordan",
  "Kazakhstan",
  "Kenya",
  "Kiribati",
  "Korea, North",
  "Korea, South",
  "Kosovo",
  "Kuwait",
  "Kyrgyzstan",
  "Laos",
  "Latvia",
  "Lebanon",
  "Lesotho",
  "Liberia",
  "Libya",
  "Liechtenstein",
  "Lithuania",
  "Luxembourg",
  "Macedonia",
  "Madagascar",
  "Malawi",
  "Malaysia",
  "Maldives",
  "Mali",
  "Malta",
  "Marshall Islands",
  "Mauritania",
  "Mauritius",
  "Mexico",
  "Federated States of Micronesia",
  "Moldova",
  "Monaco",
  "Mongolia",
  "Montenegro",
  "Morocco",
  "Mozambique",
  "Myanmar (Burma)",
  "Namibia",
  "Nauru",
  "Nepal",
  "Netherlands",
  "New Zealand",
  "Nicaragua",
  "Niger",
  "Nigeria",
  "Norway",
  "Oman",
  "Pakistan",
  "Palau",
  "Panama",
  "Papua New Guinea",
  "Paraguay",
  "Peru",
  "Philippines",
  "Poland",
  "Portugal",
  "Puerto Rico",
  "Qatar",
  "Romania",
  "Russia",
  "Rwanda",
  "Saint Kitts and Nevis",
  "Saint Lucia",
  "Saint Vincent and the Grenadines",
  "Samoa",
  "San Marino",
  "Sao Tome and Principe",
  "Saudi Arabia",
  "Senegal",
  "Serbia",
  "Seychelles",
  "Sierra Leone",
  "Singapore",
  "Slovakia",
  "Slovenia",
  "Solomon Islands",
  "Somalia",
  "South Africa",
  "South Sudan",
  "Spain",
  "Sri Lanka",
  "Sudan",
  "Suriname",
  "Swaziland",
  "Sweden",
  "Switzerland",
  "Syria",
  "Taiwan",
  "Tajikistan",
  "Tanzania",
  "Thailand",
  "Togo",
  "Tonga",
  "Trinidad and Tobago",
  "Tunisia",
  "Turkey",
  "Turkmenistan",
  "Tuvalu",
  "Uganda",
  "Ukraine",
  "United Arab Emirates",
  "United Kingdom",
  "United States",
  "Uruguay",
  "Uzbekistan",
  "Vanuatu",
  "Vatican City",
  "Venezuela",
  "Vietnam",
  "Yemen",
  "Zambia",
  "Zimbabwe",
];

export const SAAS_DATA_SAVE_SUCCESS = "Data saved successfully.";

export const OTHERCARDS = [
  /[1-9]/,
  /\d/,
  /\d/,
  /\d/,
  " ",
  /\d/,
  /\d/,
  /\d/,
  /\d/,
  " ",
  /\d/,
  /\d/,
  /\d/,
  /\d/,
  " ",
  /\d/,
  /\d/,
  /\d/,
  /\d/,
];
export const AMERICANEXPRESS = [
  /[1-9]/,
  /\d/,
  /\d/,
  /\d/,
  " ",
  /\d/,
  /\d/,
  /\d/,
  /\d/,
  /\d/,
  /\d/,
  " ",
  /\d/,
  /\d/,
  /\d/,
  /\d/,
  /\d/,
];
export const EXPIRYDATE = [/[0-9]/, /\d/, "/", /\d/, /\d/];
export const CVC = [/[0-9]/, /\d/, /\d/, /\d/];
export const ROW_PER_PAGE_OPTIONS = [25, 50, 100];
export const RESET_PASSWORD_TEXT =
  "In order to protect your account, make sure your password :";
export const MIN_PASSWORD_LENGTH_TEXT = "is longer than 7 characters";
export const PASSWORD_LETTER_CONSTRAINT =
  "should contain at least one lower case letter (a-z), one upper case letter (A-Z) and one number";
export const PASSWORD_CONSTRAINTS_FAILED_MESSAGE =
  "Your password should contain minimum 8 characters, at least one lower case letter (a-z), one upper case letters (A-Z) and one number";
export const PASSWORD_RESET_SUCCESS_MESSAGE =
  "Your password has been updated successfully";

export const PAYMENT_VALIDATION_MESSAGE = {
  addCard: "Please add a card to proceed with payment.",
  selectCard: "Please select a card to proceed with payment.",
};

export const POLICY_NOT_ACCEPTED_MESSAGE = {
  registration:
    "Please check the box to confirm that you have read and agree to the Course Registration Policy before proceeding with payment.",
  renewal:
    "Please check the box to confirm that you have read and agree to the Course Renewal Policy before proceeding with payment.",
};

export const permissionNames = {
  account: "account",
  masterOfOralImplantologyProgram: "masterOfOralImplantologyProgram",
  externship: "externship",
  observationTrack: "observationTrack",
  dentalAssistantObservationTrack: "dentalAssistantObservationTrack",
  cadaverProgram: "cadaverProgram",
  onlineProgram: "onlineProgram",
  onlineProgramTestAttempts: "onlineProgramTestAttempts",
  purchaseOnlinePrograms: "purchaseOnlinePrograms",
  subscriptions: "subscriptions",
  speakers: "speakers",
  saasAdmin: "saasAdmin",
  user: "user",
  deleteAccount: "deleteAccount",
  deleteCourse: "deleteCourse",
  deleteSaaS: "deleteSaaS",
  deleteCategories: "deleteCategories",
  deleteUser: "deleteUser",
};
export const CATEGORY_PARENT = {
  EXTERNSHIP: "Live-Patient Surgical Externships - Participation Track",
  EXTERNSHIP_OBSERVATION_TRACK:
    "Live-Patient Surgical Externships - Observation Track",
  EXTERNSHIP_DENTAL_ASSISTANT_OBSERVATION_TRACK:
    "Live-Patient Surgical Externships - Dental Assistant Observation Track",
  ONLINE_PROGRAM: "Online CE Programs",
  CADAVER_PROGRAM: "Hands-On Cadaver Programs",
  MASTER_OF_ORAL_IMPLANTOLOGY: "Master of Oral Implantology Program",
  LIVE_LECTURES: "Live Lectures",
};
export const CATEGORY_TYPE = {
  EXTERNSHIP: "ciicourse",
  EXTERNSHIP_OBSERVATION_TRACK: "ciicourse-observationTrack",
  EXTERNSHIP_DENTAL_ASSISTANT_OBSERVATION_TRACK:
    "ciicourse-dentalAssistantObservationTrack",
  MASTER_OF_ORAL_IMPLANTOLOGY: "masterOfOralImplantologyProgram",
  ONLINE_PROGRAM: "onlinePrograms",
  CADAVER_PROGRAM: "handsOnProgram",
  LIVE_LECTURES: "liveLectures",
};

export const LIVE_LECTURE_COURSE_FEE = 39;

// Modal contents shown after a successful payment in the dentist flow.
export const PAYMENT_SUCCESS_CONTENTS = [
  "paymentSuccessFull",
  "paymentSuccessDeposit",
  "paymentSuccessBalance",
];

// Mirrors DIRECT_ACCESS_PROGRAMS_ON_PURCHASE on the API: these programs unlock
// as soon as tuition is paid in full (never on a deposit-only payment).
export const DIRECT_ACCESS_TYPES = [
  CATEGORY_TYPE.ONLINE_PROGRAM,
  CATEGORY_TYPE.EXTERNSHIP,
  CATEGORY_TYPE.EXTERNSHIP_OBSERVATION_TRACK,
  CATEGORY_TYPE.EXTERNSHIP_DENTAL_ASSISTANT_OBSERVATION_TRACK,
  CATEGORY_TYPE.CADAVER_PROGRAM,
];

export const QUESTIONNAIRE_CATEGORY_TYPES = [
  CATEGORY_TYPE.ONLINE_PROGRAM,
  CATEGORY_TYPE.EXTERNSHIP,
  CATEGORY_TYPE.EXTERNSHIP_OBSERVATION_TRACK,
  CATEGORY_TYPE.CADAVER_PROGRAM,
];

// constants/quizInstructions.js

export const QUIZ_INSTRUCTIONS = [
  {
    text: (
      <>
        You need to score <strong>70% or higher</strong> to pass and receive
        your certificate.
      </>
    ),
  },
  {
    text: (
      <>
        Questions may be either:
        <ul style={{ marginTop: 8, marginBottom: 0, paddingLeft: 20 }}>
          <li>
            <strong>Single-answer questions</strong> (one correct option) or
          </li>
          <li>
            <strong>Multi-select questions</strong> (multiple correct options).
          </li>
        </ul>
      </>
    ),
  },
  {
    text: <>Questions are presented one at a time.</>,
  },
  {
    text: (
      <>
        After submitting each answer, you will immediately see whether your
        response was correct or incorrect.
      </>
    ),
  },
  {
    text: (
      <>
        Once an answer has been submitted, you cannot return to a previous
        question.
      </>
    ),
  },
  {
    text: (
      <>
        There is no time limit for this assessment, so please take your time and
        read each question carefully.
      </>
    ),
  },
  {
    text: (
      <>
        If you close your browser or navigate away during the assessment, your
        progress will be saved. You may resume the assessment within 24 hours.
        After 24 hours, your attempt will expire and you will need to start a
        new attempt from the beginning.
      </>
    ),
  },
  {
    text: (
      <>
        Your final result will be displayed immediately after you submit your
        last answer.
      </>
    ),
  },
  {
    text: (
      <>
        If you do not pass, you may retake the quiz as many times as you wish.
      </>
    ),
  },
];

export const CATEGORY_NODE_TYPE = {
  GROUP: "group",
  CATEGORY: "category",
  SUBCATEGORY: "subcategory",
};
